import { jsx as j } from "react/jsx-runtime";
import { useRef as P, useState as b, useCallback as y, useEffect as m } from "react";
import M from "react-dom";
import "./index.es4.js";
import "./index.es20.js";
import "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es6.js";
import { usePLMapboxRefV2 as L } from "./index.es8.js";
import "./index.es99.js";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "react-map-gl";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "@sentry/react";
import "./index.es43.js";
import "lodash";
import "./index.es84.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
const Lt = ({
  lat: t,
  lng: r,
  offsetX: s = 0,
  offsetY: c = 0,
  zIndex: f = 1e3,
  pointerEvents: u = "none",
  // prevent pointer events by default
  mapId: a,
  children: d
}) => {
  const o = L(a), C = o.getContainer(), e = P(!0), [n, l] = b({ x: 0, y: 0 }), p = y(
    ({ lng: i, lat: R }) => {
      e.current && l(o.project([i, R]));
    },
    [o]
  );
  m(() => {
    const i = () => p({ lat: t, lng: r });
    return o.on("render", i), () => {
      o.off("render", i);
    };
  }, [t, r, o, p]), m(() => {
    p({ lat: t, lng: r });
  }, [t, r, p]), m(() => () => {
    e.current = !1;
  }, []);
  const x = {
    position: "absolute",
    pointerEvents: u,
    top: n.y + c,
    left: n.x + s,
    zIndex: f
  };
  return M.createPortal(
    /* @__PURE__ */ j("div", { style: x, children: d }),
    C
  );
};
export {
  Lt as PLPopup
};
//# sourceMappingURL=index.es163.js.map
